// Figma: https://www.figma.com/design/nykbXADUTliE6d7xv6FjcQ/NEW-TSAB-Shared-Customer-Library?node-id=3265-56508
// Component: PassengerInfo
// Shows passenger name + phone number with optional edit button
// States: normal | disabled (opacity-38)

import classnames from 'classnames'
import { Icon } from '~/components'

function UserIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <path d="M10 12.5C7.35827 12.5 5.009 13.7755 3.51333 15.755C3.19142 16.181 3.03047 16.394 3.03573 16.6819C3.0398 16.9043 3.17947 17.1849 3.35447 17.3222C3.58099 17.5 3.89489 17.5 4.52269 17.5H15.4773C16.1051 17.5 16.419 17.5 16.6455 17.3222C16.8205 17.1849 16.9602 16.9043 16.9643 16.6819C16.9695 16.394 16.8086 16.181 16.4867 15.755C14.991 13.7755 12.6417 12.5 10 12.5Z" stroke="#17181A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10 10C12.0711 10 13.75 8.32107 13.75 6.25C13.75 4.17893 12.0711 2.5 10 2.5C7.92893 2.5 6.25 4.17893 6.25 6.25C6.25 8.32107 7.92893 10 10 10Z" stroke="#17181A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default function PassengerInfo({ name, phone, onEdit, disabled }) {
  return (
    <div className={classnames('flex gap-3 items-center py-3 w-full', disabled && 'opacity-[0.38]')}>
      {/* Icon — 44px container, 20px icon centred */}
      <div className="shrink-0 size-11 flex items-center justify-center">
        <UserIcon />
      </div>

      {/* Text */}
      <div className="flex-1 flex flex-col items-start min-w-0">
        <span className="text-[17px] font-medium tracking-[-0.34px] leading-[22px] text-on-surface">{name}</span>
        {phone && (
          <span className="text-[15px] leading-5 text-on-surface-variant">{phone}</span>
        )}
      </div>

      {onEdit && !disabled && (
        <button type="button" onClick={onEdit} className="shrink-0 p-2 -mr-2" aria-label="Redigera passagerarinformation">
          <Icon id="pen" />
        </button>
      )}
    </div>
  )
}
